import { DoctorDTO } from '@/data/DTOs/schedule/DoctorDTO';
import { useMemo } from 'react';
import { handleRequestError, useRestClient } from '../useRestClient';
import {
  DOCTORS_LIST_URL,
  DOCTORS_LIST_URL_ONLINE,
} from '@/constants/constants';

export function useDoctorService() {
  const { restClient } = useRestClient();

  const getDoctors = async (idLocation?: string): Promise<DoctorDTO[]> => {
    try {
      const url = idLocation
        ? `${DOCTORS_LIST_URL}/location/${idLocation}`
        : DOCTORS_LIST_URL_ONLINE;

      const response = await restClient.get(url);

      const noPreference: DoctorDTO = {
        id: '-',
        name: 'schedule:screen_choose_doctor_no_prefence',
        resourceId: '',
        gender: '',
        agenda: {
          locationId: '',
          weekDay: 0,
        },
      };

      const doctorArray = [...response.data] as DoctorDTO[];
      doctorArray.unshift(noPreference);

      return doctorArray;
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  const getDoctorById = async (
    idLocation: string,
    resourceId: string
  ): Promise<DoctorDTO | null> => {
    try {
      const response = await restClient.get(
        `${DOCTORS_LIST_URL}/location/${idLocation}`
      );

      return response.data.find((doctor: DoctorDTO) => {
        resourceId == doctor.id;
      });
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  return useMemo(
    () => ({
      getDoctorById,
      getDoctors,
    }),
    []
  );
}
